<template>
    <div class="basicData" v-wechat-title="$t('通配参数维护')">
        <Title :title="$t('通配参数维护')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('通配参数') }}</span></div>
                    <div class="input_box">
                        <el-input v-model.trim="parameters.parameters.wildcardEn" clearable maxLength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('中文名称') }}</span></div>
                    <div class="input_box">
                        <el-input v-model.trim="parameters.parameters.wildcardCn" clearable maxLength="15"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="search_btn" @click="search">{{ $t('查询') }}</button>
            <button type="button" class="download_btn" @click="downloadExcel">{{ $t('下载模板') }}</button>
            <button type="button" class="import_btn" @click="importExcel" v-permissions="26031106">{{ $t('导入') }}</button>
            <button type="button" class="delete_btn" @click="deleteList" v-permissions="26031105">{{ $t('删除') }}</button>
            <button type="button" class="add_btn" @click="visible = true" v-permissions="26031102">{{ $t('新建') }}</button>
        </div>
        <div class="table_box">
            <el-table :data="list" v-loading="loading" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column :label="$t('通配参数')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.wildcardEn || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('中文名称')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.wildcardCn || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center" width="150">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <span class="table_btn edit" :title="$t('编辑')" @click.stop="edit(scope.row)"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_box">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="10"
                    :current-page="parameters.page"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageInfo.total">
            </el-pagination>
        </div>
        <el-dialog :visible="visible" center :title="$t('新建/编辑通配参数')" :show-close="false" width="550px">
            <el-form ref="form" :model="addParameters" label-width="108px">
                <el-form-item :label="$t('通配参数')">
                    <div style="width: 350px;">
                        <el-input v-model="addParameters.wildcardEn" clearable maxLength="15"></el-input>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('中文名称')">
                    <div style="width: 350px;">
                        <el-input v-model="addParameters.wildcardCn" clearable maxLength="15"></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog_footer">
                <button type="button" class="back_btn" @click="cancelBtn">{{ $t('取消') }}</button>
                <button type="button" class="save_btn" @click="add" v-permissions="26031102">{{ $t('确定') }}</button>
            </span>
        </el-dialog>
        <input id="file" @change="changeFile($event)" v-show="false" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel " multiple="multiple">
    </div>
</template>

<script>
    export default {
        data () {
            return {
                addParameters: {
                    id: null,
                    wildcardEn: '',
                    wildcardCn: ''
                },
                visible: false,
                loading: false,
                list: [],
                pageInfo: {
                    total: 0
                },
                parameters: {
                    page: 1,
                    rows: 10,
                    parameters: {
                        wildcardEn: '',
                        wildcardCn: ''
                    }
                },
                deleteIdList: [],
                uploadFile: {
                    file: ''
                }
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                this.getList()
            },
            downloadExcel () {
                this.$store.dispatch('a:common/readGlobalParam', {paramName: 'importWildcardParam'}).then(
                    res => {
                        window.open(res)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            changeFile (el) {
                this.uploadFile.file = el.target.files[0]
                this.$loading({
                    lock: true,
                    text: this.$t('正在导入') + '...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch('a:maintainWillcardParams/importExcelWildCardParam', this.uploadFile).then(
                    res => {
                        this.$loading().close()
                        res.success ? this.$message.success(this.$t('保存成功')) : this.$message({type: 'error', dangerouslyUseHTMLString: true, message: res.errMsg});
                        this.getList()
                    },
                    rej => {
                        this.$loading().close()
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            importExcel () {
                document.getElementById('file').value = ''
                document.getElementById('file').click()
            },
            search () {
                this.parameters.page = 1
                this.getList()
            },
            add () {
                if (!this.addParameters.wildcardEn) {
                    this.$message.info(this.$t('请输入') + this.$t('通配参数'));
                    return false
                }
                if (!this.addParameters.wildcardCn) {
                    this.$message.info(this.$t('请输入') + this.$t('中文名称'));
                    return false
                }
                this.$store.dispatch('a:maintainWillcardParams/save', this.addParameters).then(
                    res => {
                        this.$message.success(this.$t('保存成功'))
                        this.visible = false
                        this.addParameters = {
                            id: null,
                            wildcardEn: '',
                            wildcardCn: ''
                        }
                        this.getList()
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            edit (item) {
                this.addParameters = JSON.parse(JSON.stringify(item))
                this.visible = true
            },
            cancelBtn () {
                this.addParameters = {
                    id: null,
                    wildcardEn: '',
                    wildcardCn: ''
                }
                this.visible = false
            },
            handleSelectionChange (value) {
                let idList = []
                for (let item of value) {
                    idList.push(item.id)
                }
                this.deleteIdList = idList
            },
            deleteList () {
                if (this.deleteIdList.length === 0) {
                    this.$message.info(this.$t('请先选择后再删除'));
                    return false
                }
                this.$confirm(this.$t('删除后无法恢复，确认删除选择的记录吗'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(() => {
                    this.$store.dispatch('a:maintainWillcardParams/deleteMultiple', {ids: this.deleteIdList.join(), deleteAll: false}).then(
                        res => {
                            if (this.pageInfo.isLastPage && this.list.length === this.deleteIdList.length && this.parameters.page > 1) {
                                this.parameters.page--
                            }
                            this.$message.success(`${ this.$t('成功删除') } ${ this.deleteIdList.length } ${ this.$t('条数据') }`)
                            this.getList()
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {

                });
            },
            handleSizeChange (val) {
                this.parameters.rows = val
                this.getList()
            },
            handleCurrentChange (val) {
                this.parameters.page = val
                this.getList()
            },
            getList () {
                this.loading = true
                this.$store.dispatch('a:maintainWillcardParams/getList', this.parameters).then(
                    res => {
                        this.list = res.list || []
                        this.pageInfo = res.pageInfo
                        this.loading = false
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                        this.loading = false
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
